// https://vuex.vuejs.org/en/state.html

export default {
  name: null,
  account: null,
  accountCategory: null,
  business_id: null,
  background: null,
  avatar: null,
  bio: null,
  phone: null,
  mobile: null,
  address: null,
  model: {},
};
